<template>
  <div>
    <section id="sub_visual" class="pic11">
      <p>이트너스 회의실예약 소개 </p>
      <span>About etnersbooking Service</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con11 clear">
        <h6>함께쓰는 소통의 공간,<br/>
          쉽게 효율적이게!</h6>
        <span class="ctext1">함께  쓰는 사무/회의실공간을 보다  쉽고 빠르게 예약하고<br>
      일정공유로  스마트한 오피스를 지원합니다. </span>
        <p class="ctext2 mr0 t-ar pt100"><span class="cbig">Why</span><span class="pl0">etners Booking?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_37.png" width="104" height="104" alt=""/></p>
              <h6>쉽고 효율적인 함께 쓰는 공간</h6>
              <p>사내 회의 일정을 한번에 확인하고, 회의실 예약을 할수 있어 업무 일정관리가 더욱 간편합니다.</p>
            <li>
              <p><img src="../../assets/images/c_im_38.png" width="104" height="104" alt=""/></p>
              <h6>나의 예약 목록 확인</h6>
              <p>내가 선택한 예약 및 대기 목록을 한눈에 확인하고 , 예약 상태를 손쉽게 편집하여 예약 후에도 효율적인 관리가 가능합니다.</p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_39.png" width="104" height="104" alt=""/></p>
              <h6>차량관리까지 포함한 사내 자원관리가능</h6>
              <p>회의실 뿐만 아니라 사내 차량, 비품 등 카테고리를 설정해 모든 임직원이 공유할 수 있는 사내 자산을 효율적으로 관리할 수 있습니다. </p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_40.png" width="104" height="104" alt=""/></p>
              <h6>차량관리는 운행일지/ 주유대장 기능 제공</h6>
              <p>세법 개정에 따른 법인차량 운행일지 및 주유대장을 작성할수 있으며 엑셀 다운로드로로  국세청 제출 등에 편리하게 사용할 수 있습니다.</p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
      </section>
    </main>
  </div>
</template>

<script>
  export default {
    name : "etnersconcierge",
    data() {
      return{

      }
    },
    methods:{
      goConcierge:function () {
        this.$router.push({name:'Concierge'})
      }
    }
  }

</script>
